package eu.codlab.navigation

import androidx.compose.runtime.Composable
import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import androidx.navigation.toRoute
import kotlin.reflect.KClass
import kotlin.reflect.KType

abstract class Router<T : RouteParameterTo>(private val klass: KClass<T>) {
    open val typeMap: Map<KType, NavTypeWrapper<*>>?
        get() = null

    fun display(navGraphBuilder: NavGraphBuilder) {
        navGraphBuilder.composable(
            route = klass,
            typeMap = typeMap?.map { (key, value) ->
                key to value.navType
            }?.toMap() ?: emptyMap()
        ) {
            println("showing route ${it.destination.route}")
            it.toRoute<T>(klass).let { parameters ->
                Show(parameters)
                setPath(parameters)
            }
        }
    }

    protected abstract fun routeFrom(parameters: T): String

    private fun setPath(parameters: T) = Navigation.setPath(routeFrom(parameters))

    @Composable
    protected abstract fun Show(parameters: T)

    abstract fun isMatching(route: String): Boolean

    abstract fun navigateFrom(path: String): T

    abstract fun isCurrentRoute(routeParameterTo: RouteParameterTo?): Boolean
}

abstract class RouterNoParameters<T : RouteParameterTo>(klass: KClass<T>) : Router<T>(klass) {
    abstract fun navigateTo(): NavigateTo
}

abstract class RouterParameters<T : RouteParameterTo>(klass: KClass<T>) : Router<T>(klass) {
    abstract fun navigateTo(instance: T): NavigateTo
}

abstract class Route<T : RouteParameterTo>(
    val route: String,
    val params: T,
    val deepLinks: List<String> = emptyList(),
    // val navTransition: NavTransition? = null,
    // val swipeProperties: SwipeProperties? = null,
) {
    @Composable
    abstract fun scene(
        // navigateTo: (NavigateTo) -> Unit,
        //  don't pass backStackEntry: NavBackStackEntry
        //  will need specific parameters
    )
}
